import React from "react";
import ManageServices from "../organisms/manage-services";
import { track } from "../utils/tracking";

const ManageServicesScreen = () => {
  React.useEffect(() => {
    track("manage_services_screen");
  }, []);

  return <ManageServices />;
};

export default ManageServicesScreen;
